// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// WARNING - Values under "firebase" and value of "googleApiKey" needs to be replaced from your own accounts
// If left as is, it firbase and google map related functionality will not work on LIVE instance.
export const environment = {
  module_move: false,
  telephonyEnabled: true,
  showCallDialog: false,
  callCacheTimeoutSeconds: 5,
  appVersion: '2.3.2',
  prismaApiUrl: 'https://api.m-h3.de',
  prismaApiUrlDev: 'https://api.m-h3.de',
  mh3ApiUrlProd: 'https://api.m-h3.de',
  prisma2ApiUrlProdPlayground: 'https://pg-api.m-h3.de',
  production: true,
  apiUrl: 'http://localhost:8000/api',
  wsUrl: 'ws://localhost:6001',
  openAIKey: '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',
  firebase: {
    apiKey: 'AIzaSyCSG-EGU2RLITgpjf_ogf1w47edC_DXlWc',
    authDomain: 'evolvision-rnd.firebaseapp.com',
    databaseURL: 'https://evolvision-rnd.firebaseio.com',
    projectId: 'evolvision-rnd',
    storageBucket: 'evolvision-rnd.appspot.com',
    messagingSenderId: '890895206035',
    appId: '1:890895206035:web:a6d0e1574d59ffe40bef66'
  },

  googleApiKey: 'AIzaSyDQvtYKhQflmZqUuHllKveW_f2cAcvfwL4',
  pusherKey: 'IHRE_PUSHER_KEY',
  pusherCluster: 'eu',
  // SOAP Service Konfiguration
  soapService: {
    wsdlUrl: 'http://10.1.3.62/webservice.php',
    wsdlUrlTest: 'http://10.1.3.58/webservice.php',
    credentials: {
      userLogin: 'SOAPmh3',
      userPassword: '78Muiwa',
      vendorNo: '999888182'
    }
  }
  ,
  dispoInboxAddress: 'disposition@mh3.hamburg',
  responsive: false,
  // n8n Chat – Chat Trigger Webhook (Production)
  // Hinweis: Wenn CORS im Browser Probleme macht, kann man wieder über einen API-Proxy gehen.
  n8nWebhookUrl: 'https://n8n.m-h3.de/webhook/f799466a-2c93-4d37-a9e5-5b008cd4947e/chat',
  n8nEnableStreaming: false,
  // KI-Import: Upload läuft über Laravel POST …/api/dispo/ki-import (n8n-URLs in der API-Konfiguration).
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

//old: AIzaSyAzYF6i5FT_6-40eB_t0r9BkG-B9J9tfyw
  //AIzaSyDQvtYKhQflmZqUuHllKveW_f2cAcvfwL4